import { bind, Component, createRef, h, signal, tag } from "omi";

import { NWButton } from "@/components/atoms/nw-button";
import { COMMUNITY_LINK_ASK } from "@/globals/links";
import { Timeout } from "@/types/timers";
import { tailwind } from "@/tailwind";

type Props = {
  resetActiveAction: () => void;
  onSubmit: (query: string) => void;
};

@tag("nw-highlight-toolbar-views-ask")
export class AskView extends Component<Props> {
  static css = [tailwind];
  static propTypes = {
    group: String,
  };
  private readonly CHARACTER_LIMIT = 300;
  private inputRef = createRef<HTMLInputElement>();
  private askQuery = signal<string>("");
  private timeoutId: Timeout | undefined;

  ready(): void {
    this.timeoutId = setTimeout(() => {
      this.inputRef.current?.focus();
    }, 0);
  }

  uninstall(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  @bind
  private handleSubmitAskQuery() {
    this.props.onSubmit(this.askQuery.value);
  }

  @bind
  private handleInputCapture(e: Event) {
    const target = e.target as HTMLTextAreaElement;
    const value = target.value;

    if (value.length > this.CHARACTER_LIMIT) return e.preventDefault();

    target.style.height = "auto";
    target.style.height = `${target.scrollHeight}px`;

    this.askQuery.value = value.trim();
  }

  @bind
  private handleKeyDown(e: KeyboardEvent) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      this.handleSubmitAskQuery();
    } else if (e.key === "Escape") {
      this.props.resetActiveAction();
    }
  }

  render({ resetActiveAction }: Props) {
    return (
      <div
        className="flex flex-col space-y-1 pointer-events-auto animate-fadeInFast"
        // onClick={e => {
        //   e.preventDefault();
        //   e.stopPropagation();
        // }}
      >
        <div className="mt-2 px-2">
          <textarea
            maxLength={this.CHARACTER_LIMIT}
            tabIndex={1}
            ref={e => {
              if (e) {
                e.focus();
              }
              return (this.inputRef.current = e);
            }}
            className="w-full py-1 px-2 resize-none border-none focus:outline-none focus:ring-0 overflow-hidden"
            placeholder="Ask anything..."
            onInputCapture={this.handleInputCapture}
            onKeyDown={this.handleKeyDown}
            rows={1}
          />
        </div>
        <div className="footer rounded-b-lg bg-brand-50 px-2 py-1 w-full flex items-center justify-between">
          <NWButton
            size="fit"
            type="icon"
            icon="chevron-left"
            backgroundTransparent
            onClick={resetActiveAction}
          ></NWButton>

          <NWButton
            size="fit"
            type="text"
            icon="message-question-circle"
            backgroundTransparent
            href={COMMUNITY_LINK_ASK}
          >
            Ask community
          </NWButton>
        </div>
      </div>
    );
  }
}
